import { StateType } from "@/redux/createStore"
import { createSelector } from "reselect"

export const getGuarantees = createSelector(
  (state: StateType) => state.guarantees,
  (data) => data
)
